import React from 'react';
import { ReactComponent as CompletedIcon } from 'images/completedIcon.svg';
import { Hotkeys } from 'constants/Hotkeys';
import { Option } from '../Option/Option';
import { OptionTitle, TagCatcherThrowsWrapper } from '../TagCatcherThrows/TagCatcherThrowsStyles';

interface IProps {
  onClickCallback: () => void;
  onPressHotkeyCallback: () => void;
  disabled: boolean;
}

const BaseRunnersOption: React.FC<IProps> = (props) => {
  const { onClickCallback, onPressHotkeyCallback, disabled } = props;

  const getDisplayName = () => {
    if (disabled) {
      return (
        <OptionTitle>
          Base Runners <CompletedIcon />
        </OptionTitle>
      );
    }
    return <>Base Runners</>;
  };

  return (
    <TagCatcherThrowsWrapper>
      <Option
        displayName={getDisplayName()}
        hotkeyCode={Hotkeys.BaseRunners.Option.keyCode}
        hotkeyDisplay={Hotkeys.BaseRunners.Option.hotkeyDisplay}
        value=''
        onPressHotkeyCallback={onPressHotkeyCallback}
        onClickCallBack={onClickCallback}
        data-test='BaseRunners-0'
      />
    </TagCatcherThrowsWrapper>
  );
};

export default BaseRunnersOption;
